import { call, put, take, takeEvery } from "redux-saga/effects";

import { PaginateQuery, ResponseGenerator } from "../../interfaces";
import {
  ADD_LECTURE,
  AddLectureAction,
  DELETE_LECTURE,
  DeleteLectureAction,
  GET_LECTURE,
  GetLectureAction,
  GetLecturesAction,
  UPDATE_LECTURE,
  UpdateLectureAction,
  GET_LECTURES,
  UploadLectureVideoAction,
  UPLOAD_LECTURE_VIDEO,
  GET_LECTURES_BY_LESSON,
  GetLecturesByLessonAction,
  GET_LECTURES_BY_SUBJECT,
  GetLecturesBySubjectAction,
  ToggleLectureStateAction,
  TOGGLE_LECTURE_STATE,
} from "./actionTypes";
import {
  addLectureError,
  addLectureSuccess,
  deleteLectureError,
  deleteLectureSuccess,
  getLectureError,
  getLectureSuccess,
  getLecturesByLessonError,
  getLecturesByLessonSuccess,
  getLecturesBySubjectError,
  getLecturesBySubjectSuccess,
  getLecturesError,
  getLecturesSuccess,
  toggleLectureStateError,
  toggleLectureStateSuccess,
  updateLectureError,
  updateLectureSuccess,
  uploadLectureVideoError,
  uploadLectureVideoSuccess,
} from "./actions";
import {
  addLecture,
  deleteLecture,
  getLecture,
  getLectures,
  getLecturesByLesson,
  getLecturesBySubject,
  toggleLectureState,
  updateLecture,
  uploadLectureVideo,
} from "../../helpers/backend_helper";

function* getLecturesSaga({
  payload: { request, history },
}: GetLecturesAction) {
  try {
    const response: ResponseGenerator = yield call(
      getLectures,
      request as PaginateQuery
    );
    yield put(getLecturesSuccess(response.data));
  } catch (error) {
    yield put(getLecturesError(error));
  }
}

function* getLecturesByLessonSaga({
  payload: { lessonId, history },
}: GetLecturesByLessonAction) {
  try {
    const response: ResponseGenerator = yield call(
      getLecturesByLesson,
      lessonId
    );
    yield put(getLecturesByLessonSuccess(response.data));
  } catch (error) {
    yield put(getLecturesByLessonError(error));
  }
}

function* getLecturesBySubjectSaga({
  payload: { subjectId, history },
}: GetLecturesBySubjectAction) {
  try {
    const response: ResponseGenerator = yield call(
      getLecturesBySubject,
      subjectId
    );
    yield put(getLecturesBySubjectSuccess(response.data));
  } catch (error) {
    yield put(getLecturesBySubjectError(error));
  }
}

function* getLectureSaga({ payload: { id, history } }: GetLectureAction) {
  try {
    const response: ResponseGenerator = yield call(getLecture, id);
    yield put(getLectureSuccess(response.data));
  } catch (error) {
    yield put(getLectureError(error));
  }
}

function* addLectureSaga({ payload: { request, history } }: AddLectureAction) {
  try {
    const response: ResponseGenerator = yield call(addLecture, request);
    yield put(addLectureSuccess(response.data));
  } catch (error) {
    yield put(addLectureError(error));
  }
}

function* updateLectureSaga({
  payload: { id, request, history },
}: UpdateLectureAction) {
  try {
    const response: ResponseGenerator = yield call(updateLecture, id, request);
    yield put(updateLectureSuccess(response.data));
  } catch (error) {
    yield put(updateLectureError(error));
  }
}

function* deleteLectureSaga({ payload: { id, history } }: DeleteLectureAction) {
  try {
    yield call(deleteLecture, id);
    yield put(deleteLectureSuccess(id));
  } catch (error) {
    yield put(deleteLectureError(error));
  }
}

function* uploadLectureVideoSaga({
  payload: { file, history, lectureId },
}: UploadLectureVideoAction) {
  try {
    const response: ResponseGenerator = yield call(
      uploadLectureVideo,
      file,
      lectureId
    );
    yield put(uploadLectureVideoSuccess(response.data));
  } catch (error) {
    yield put(uploadLectureVideoError(error));
  }
}

function* toggleLectureStateSaga({
  payload: { id, history },
}: ToggleLectureStateAction) {
  try {
    yield call(toggleLectureState, id);
    yield put(toggleLectureStateSuccess(id));
  } catch (error) {
    yield put(toggleLectureStateError(error));
  }
}

function* LectureSaga() {
  yield takeEvery(GET_LECTURES, getLecturesSaga);
  yield takeEvery(GET_LECTURES_BY_LESSON, getLecturesByLessonSaga);
  yield takeEvery(GET_LECTURES_BY_SUBJECT, getLecturesBySubjectSaga);
  yield takeEvery(GET_LECTURE, getLectureSaga);
  yield takeEvery(ADD_LECTURE, addLectureSaga);
  yield takeEvery(UPDATE_LECTURE, updateLectureSaga);
  yield takeEvery(DELETE_LECTURE, deleteLectureSaga);
  yield takeEvery(UPLOAD_LECTURE_VIDEO, uploadLectureVideoSaga);
  yield takeEvery(TOGGLE_LECTURE_STATE, toggleLectureStateSaga);
}

export default LectureSaga;
